export var SCOPES;
(function (SCOPES) {
    SCOPES["PRODUCT"] = "product";
    SCOPES["SITE"] = "site";
    SCOPES["NONE"] = "none";
})(SCOPES || (SCOPES = {}));
